module.exports = __webpack_public_path__ + "static/media/popular-javascript-library-in-2020.d4881e73.md";